export const EXTERNAL_LINKS = {
  jrctDomain: 'https://jrct.mhlw.go.jp/latest-detail/',
  operationManual: 'https://micin.box.com/s/dd6lrzxvppv8e4xhd3venzr4x002n7qo',
}
